






















































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import Address from "../../../store/entities/address";
import AddressModal from "../../components/address-modal.vue";
import _ from "lodash";

Vue.use(require("vue-moment"));

@Component({
  components: { AddressModal },
})
export default class ActivateWarranty extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  addressModalShow: boolean = false;
  spinShow: boolean = false;
  selectedAddress: Address = new Address();
  activateInput: any = {};
  validFullAddress = false;
  isReset = false;
  isSelectTemplateSms = true;
  templateSmses = [];
  showTemplateSmsesToSelect = true;
  updateAddress() {
    if (!Util.isNull(this.selectedAddress)) {
      this.activateInput.customerAddressNo = this.selectedAddress.addressNo;
      this.activateInput.consumerFullAddress = this.selectedAddress.fullAddress;
      this.activateInput.consumerProvinceId = this.selectedAddress.provinceId;
      this.activateInput.consumerDistrictId = this.selectedAddress.districtId;
      this.activateInput.consumerWardId = this.selectedAddress.wardId;
    } else {
      this.activateInput.customerAddressNo = "";
      this.activateInput.consumerFullAddress = "";
      this.activateInput.consumerProvinceId = 0;
      this.activateInput.consumerDistrictId = 0;
      this.activateInput.consumerWardId = 0;
    }
  }
  openModalAddress() {
    this.selectedAddress.addressNo = this.activateInput.customerAddressNo;
    this.selectedAddress.provinceId = this.activateInput.consumerProvinceId;
    this.selectedAddress.districtId = this.activateInput.consumerDistrictId;
    this.selectedAddress.wardId = this.activateInput.consumerWardId;
    this.addressModalShow = true;
  }
  callbackCheckFullAddress() {
    this.validFullAddress = true;
  }
  activate() {
    this.isReset = false;
    (this.$refs.activateForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.validateFullAddress(
          this.activateRules,
          "",
          this.callbackCheckFullAddress
        );

        if(!this.validFullAddress)
        {
          Util.showErrorMsg(this, "Địa chỉ không hợp lệ");
          return;
        }

        if(this.isSelectTemplateSms && this.activateInput.smsTemplateId == null)
        {
          Util.showErrorMsg(this, "Bắt buộc chọn 1 nội dung tin nhắn đề kích hoạt bảo hành.");
          return;
        }

        this.$Modal.confirm({
          title: this.L("Tips"),
          content: this.L("Confirm.ActivateWarranty"),
          okText: this.L("Yes"),
          cancelText: this.L("No"),
          onOk: () => {
            this.spinShow = true;
            this.$store
              .dispatch({
                type: "warrantyActivation/activate",
                data: this.activateInput,
              })
              .then(() => {
                this.reset();
                Util.showSuccessMsg(this, "Success.ActivateWarranty");
              })
              .finally(() => {
                this.spinShow = false;
              });
          },
        });
      }
    });
  }
  reset() {
    this.spinShow = false;
    this.addressModalShow = false;
    this.validFullAddress = false;
    this.activateInput = {};
    this.isReset = true;
    this.selectedAddress = new Address();
    this.isSelectTemplateSms = true;
    this.showTemplateSmsesToSelect = true;
    this.templateSmses = [];
  }

  onSelectTemplateSms(){
    if(this.isSelectTemplateSms == true)
    {
      if(this.activateInput.hiddenCode != '' && this.activateInput.hiddenCode != undefined)
      {
        this.showTemplateSmsesToSelect = true;
        this.getTemplateSmses();
      }
      else{
        this.showTemplateSmsesToSelect = false;
        this.onResetTemplateSmses();
      }
    }
    else
    {
      this.showTemplateSmsesToSelect = false;
      this.onResetTemplateSmses();
    }
   
  }

  onResetTemplateSmses() {
    this.templateSmses = [];
    this.activateInput.smsTemplateId = null;
  }

  onCheckValidHiddenCode(){
    if(this.activateInput.hiddenCode == '' || this.activateInput.hiddenCode == undefined)
      return;
    
    this.activateInput.smsTemplateId = null;
    this.spinShow = true;
    this.$store
      .dispatch({
        type: "warrantyActivation/checkHiddenCode",
        data: this.activateInput,
      })
      .then(() => {
        if(this.isSelectTemplateSms == true){
          this.showTemplateSmsesToSelect = true;
          this.getTemplateSmses();
        } 
        this.spinShow = false;
      })
      .catch(() => {
        this.spinShow = false;
        this.templateSmses = [];
        this.activateInput.smsTemplateId = null;
      });
    
  }

  getTemplateSmses(){
    this.spinShow = true;
    this.$store
      .dispatch({
        type: "warrantyActivation/getTemplateSmsOfCategoryCollectionCode",
        data: this.activateInput,
      })
      .then((result) => {
        this.templateSmses = result;
        this.activateInput.smsTemplateId = null;
      })
      .catch(() => {
        this.spinShow = false;
      })
      .finally(() => {
        this.spinShow = false;
      });
  }

  onSelectDetailTemplateSms(row)
  {
    _.forEach(this.templateSmses, e => {
      if(e.smsTemplateId == row.smsTemplateId){
        e.isSelected = true;
      }
      else{
        e.isSelected = false;
      }
    });
    this.activateInput.smsTemplateId = row.smsTemplateId;
  }

  columns = [
    {
      title: "STT",
      width: 50,
      slot: "orderNum",
    },
    {
      title: Util.L("Category"),
      width: 250,
      key: "categoryCode",
      render:(h:any,params:any)=>{
          return h("span", `${params.row.categoryCode} - ${params.row.categoryName}`);
      }
    },
    {
      title: "Loại khách hàng",
      width: 250,
      key: "customerTypeName",
    },
    {
      title: "Nội dung tin nhắn",
      with: 450,
      key: "contentTemplate",
    },
    {
      title: "Tin nhắn mặc định",
      width: 100,
      slot: "isDefault",
    },
    {
      title: "Chọn",
      width: 100,
      slot: "isSelected",
    }
  ];

  async created() {}
  
  validateFullAddress(rule, value, callback) {
    if (
      this.isReset === false &&
      (_.isNil(this.activateInput.consumerFullAddress) ||
        _.isEmpty(this.activateInput.consumerFullAddress))
    ) {
      callback(
        new Error(this.L("Error.RequiredField0", undefined, this.L("Address")))
      );
    } else {
      callback();
    }
  }

  activateRules = {
    hiddenCode: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("HiddenCode")
        ),
        trigger: "blur",
      },
    ],
    consumerFullAddress: [
      {
        required: true,
        validator: this.validateFullAddress,
        trigger: "change",
      },
    ],
    consumerPurchaseDate: [
      {
        required: true,
        type: "date",
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("ConsumerPurchaseDate")
        ),
        trigger: "blur",
      },
    ],
    consumerName: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("ConsumerName")
        ),
        trigger: "blur",
      },
    ],
    consumerPhone: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField0",
          undefined,
          this.L("ConsumerPhone")
        ),
        trigger: "blur",
      },
    ],
  };
}
